import { render, staticRenderFns } from "./ProcessWarnArea.vue?vue&type=template&id=dbe5d67c&scoped=true"
import script from "./ProcessWarnArea.vue?vue&type=script&lang=js"
export * from "./ProcessWarnArea.vue?vue&type=script&lang=js"
import style0 from "./ProcessWarnArea.vue?vue&type=style&index=0&id=dbe5d67c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe5d67c",
  null
  
)

export default component.exports